// Import dayjs and necessary plugins
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import advancedFormat from 'dayjs/plugin/advancedFormat';

// Extend dayjs with plugins
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);

export const formatDateToLocal = (dateString: string) => {
  // Parse the input date string in UTC format
  const dateInUTC = dayjs.utc(dateString);

  // Convert it to the user's local timezone
  const localDate = dateInUTC.tz(dayjs.tz.guess());

  // Format the date into a human-readable format
  const formattedDate = localDate.format('dddd, MMMM Do [at] h:mma');

  return formattedDate;
}

// export const getStartAndEndTime = (interval = 7) => {
//   const now = new Date();

//   // Calculate the most recent midnight in UTC
//   const startOfToday = new Date(Date.UTC(
//     now.getUTCFullYear(),
//     now.getUTCMonth(),
//     now.getUTCDate(),
//     0, 0, 0, 0
//   ));

//   const startTime = `${startOfToday.toISOString().split('T')[0]}T24:00:00.000000Z`;

//   // Calculate the end time as midnight (T24) after the interval in UTC
//   const endOfInterval = new Date(Date.UTC(
//     startOfToday.getUTCFullYear(),
//     startOfToday.getUTCMonth(),
//     startOfToday.getUTCDate() + interval,
//     0, 0, 0, 0
//   ));

//   const endTime = `${endOfInterval.toISOString().split('T')[0]}T24:00:00.000000Z`;

//   return { startTime, endTime };
// };

export const getStartAndEndTime = () => {
  const now = new Date();

  // Calculate the startTime: 30 minutes from now
  const startTime = new Date(now.getTime() + 30 * 60 * 1000);

  // Calculate the endTime: 7 days from startTime
  const endTime = new Date(startTime.getTime() + 7 * 24 * 60 * 60 * 1000);

  // Format the dates in the required format
  const formatDate = (date: any) => {
    return date.toISOString().replace('Z', '.000000Z');
  };

  return {
    startTime: formatDate(startTime),
    endTime: formatDate(endTime),
  };
}